/*
  Sponsorship monthly rate:
    1. window.sponsorship_monthly_rate      - injected per page load by wvus-utils (WordPress)
    2. process.env.SPONSORSHIP_MONTHLY_RATE - inlined at build time by DefinePlugin

  No in-source default. SPONSORSHIP_MONTHLY_RATE is required for every build
  (webpack.config.js refuses to build without it), so tier 2 is always a valid positive
  number and no rate literal in this repo can go stale after a rate change.

  Every process.env key read here needs a matching DefinePlugin entry in webpack.config.js.
  Webpack 5 does not polyfill process, so an uncovered read is a browser ReferenceError.

  Traditional only - this app renders no Chosen rate.
*/

// A getter, not a constant: the host page's inline script may not have run at module load.
export const getSponsorshipMonthlyRate = () => {
  const injected = Number(
    typeof window !== "undefined" ? window.sponsorship_monthly_rate : undefined
  );

  return Number.isFinite(injected) && injected > 0
    ? injected
    : Number(process.env.SPONSORSHIP_MONTHLY_RATE);
};
